import * as React from 'react'
import { useState } from 'react'
import { addMonths, subMonths, format } from 'date-fns'

import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { monthKeys } from '@/modules/shared/constants/months'
import { DateCalendar } from './DateCalendar'
import { faChevronLeftSolid, faChevronRightSolid, FaIcon } from '@/lib/fa'
type DatePickerSingleProps = {
  value?: string | null
  // Dzien, na ktorym otwiera sie kalendarz, gdy pole jest puste.
  initialDate?: string | null
  submit: (fullDate: string) => void
  setPreview?: (fullDate: string) => void
  confirmSelection?: boolean
}
const parseDateString = (value: string): Date => {
  const [yearStr, monthStr, dayStr] = value.trim().split('-')
  const day = parseInt(dayStr, 10)
  const month = parseInt(monthStr, 10) - 1
  const year = parseInt(yearStr, 10)
  return new Date(year, month, day)
}
const DatePickerPopup: React.FC<DatePickerSingleProps> = ({
  value,
  initialDate,
  submit,
  setPreview,
  confirmSelection = false,
}) => {
  const { t } = useLocalize()
  const valueDate = value ? parseDateString(value) : null
  const [currentDate, setCurrentDate] = useState<Date>(
    valueDate ??
      (initialDate ? parseDateString(initialDate) : null) ??
      new Date(),
  )
  const [selectedDate, setSelectedDate] = useState<Date | null>(valueDate)

  const handleDayClick = (day: Date) => {
    setSelectedDate(day)

    const formatted = format(day, 'YYYY-MM-DD')

    if (!confirmSelection) {
      submit(formatted)
      return
    }

    if (setPreview) setPreview(formatted)
  }

  const handlePreviousMonth = () => setCurrentDate(subMonths(currentDate, 1))
  const handleNextMonth = () => setCurrentDate(addMonths(currentDate, 1))

  const handleSubmit = () => {
    if (!selectedDate) return
    submit(format(selectedDate, 'YYYY-MM-DD'))
  }

  return (
    <div className="tw-z-[9999] tw-w-[350px] tw-select-none tw-rounded-xl tw-bg-white tw-p-2 tw-font-sans tw-shadow">
      <div className="tw-flex tw-justify-between tw-space-x-4 tw-pb-3">
        <div className="tw-flex-1">
          <div className="tw-flex tw-items-center tw-justify-between tw-p-4">
            <FaIcon
              icon={faChevronLeftSolid}
              className="tw-w-5 tw-cursor-pointer hover:tw-opacity-90"
              onClick={handlePreviousMonth}
            />

            <p className="tw-font-semibold">
              {t(`${monthKeys[currentDate.getMonth()]}`)}{' '}
              {currentDate.getFullYear()}
            </p>
            <FaIcon
              icon={faChevronRightSolid}
              className="tw-w-5 tw-cursor-pointer hover:tw-opacity-90"
              onClick={handleNextMonth}
            />
          </div>

          <DateCalendar
            currentMonth={currentDate}
            startDate={selectedDate}
            type="singleDate"
            handleDayClick={handleDayClick}
          />
        </div>
      </div>

      {confirmSelection && (
        <div className="tw-flex tw-justify-end tw-p-3">
          <button
            onClick={handleSubmit}
            disabled={!selectedDate}
            className={`tw-rounded-lg tw-p-3 tw-pt-0 tw-text-sm tw-font-medium hover:tw-opacity-90 ${
              selectedDate
                ? 'tw-bg-primary tw-text-white'
                : 'tw-bg-content-base/20 tw-text-gray-400'
            }`}
          >
            Zatwierdź
          </button>
        </div>
      )}
    </div>
  )
}

export default DatePickerPopup
